let plusExtends = (fn) => {
  if (window.plus) {
    fn()
  } else {
    document.addEventListener('plusready', fn, false)
  }
}

export default plusExtends



// WEBPACK FOOTER //
// ./src/config/plus.js